import { render } from "./InfoBoard.vue?vue&type=template&id=6e1f68cc"
import script from "./InfoBoard.vue?vue&type=script&lang=js"
export * from "./InfoBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__